import store from 'src/store';
import { split, toUpper, map, join, take, head } from 'ramda';
import { SHORTNAME_GU, SHORTNAME_BU } from 'src/services/constants';

export const toUpperFirstTwo = (name: any, noneAsGuest: boolean) => {
  if (name) {
    const sp = split(/\s+/, name);
    const initials = join('', take(2, map((i) => head(i), sp)));
    return toUpper(initials);
  }
  return noneAsGuest ? SHORTNAME_GU : SHORTNAME_BU;
};

export const getFriendlyName = () => {
  const auth = store.getState().authentication;
  if (auth) {
    const accountEmail = auth.accountEmail;
    return toUpperFirstTwo(accountEmail, true);
  }
  return SHORTNAME_GU;
};

export const getFriendlyNameForApp = (name: string) => {
  return toUpperFirstTwo(name, false);
};
